import React, { useEffect, useState } from "react";
import { CssBaseline, Box, Typography, CircularProgress, Grid }
  from "@mui/material"; 
import Header from "../components/registration/header";
import MetaDecorator from "../services/meta_decorator";
import Footer from "../components/shared/footer";
import AccessLocalStorage from "../services/localStorage";
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { useHistory } from 'react-router-dom';
import { getApiUrl } from "../services/api_service";
import { bodyBg2, footerContainer, fullHeight, pcolor, rcolor } from "../style2";

export default function DashboardList() {
  const ls = new AccessLocalStorage();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  
  let professional = ls.getProfessional();
  const history = useHistory();
  const [autismdata, setAutismData] = useState(null)
  useEffect(() => {
    setLoading(true);
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }
    //const token = authTokens.accessToken;
    const url = getApiUrl();
    fetch(`${getApiUrl()}/patientuser/autismdashboardstats`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          response.json().then(data => {
            setAutismData(data);
          })
        } else if (response.status == 401) {
          setError("Unauthorized access");
        }
        else {
          setError("Unable to process your request.");
        }
      })

      .catch((err) => {
        setError(err.message || "An error occurred.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  return (
    <Box sx={{ ...bodyBg2, ...fullHeight }}>
      <CssBaseline />
      <MetaDecorator
        title={"EnrichMyCare - Login"}
        description={"Login using your professional account"}
      />
      <Header />
      <Typography variant="h1"
        sx={{ color: rcolor, fontSize: "1.7rem", fontWeight: "bold", margin: "30px 0px 30px 30px" }}>
        Welcome {professional !== null ? professional.name : null}</Typography>
      <Box sx={{ p: "2rem" }} >
        <Grid container >
          <Grid item xs={12} md={10} lg={8}>
            <Box p={5} sx={{ cursor: "pointer", backgroundColor: "#DEF4F1", margin: "0 auto", borderRadius: "10px" }} onClick={() => { history.push('/'); }}>
              <ArrowCircleRightIcon fontSize="large" style={{ float: "right", color: "#4FBFA8" }} />
              <Typography sx={{ color: pcolor, fontSize: "2.5rem", fontWeight: "bold", marginBottom: "20px" }}>Dashboard</Typography>

              <Box m={6}></Box>
              <Grid container fullWidth>
                <Grid item xs={12} md={4}>
                  <Box mb={3} sx={{ textAlign: "center", backgroundColor: "#fff", border: "#7B9390 1px solid", borderRadius: "10px", width: "90%" }}>
                    <Typography sx={{ color: pcolor, fontSize: "1.4rem", margin: "10px 0px 5px 0px" }}>Total number of children</Typography>
                    <Typography sx={{ color: rcolor, fontSize: "2.5rem", fontWeight: "bold", marginBottom: "10px" }}>{autismdata !== null ? autismdata.patientCount : loading ? <CircularProgress size={20} color="success" /> : ""}</Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box mb={3} sx={{ textAlign: "center", backgroundColor: "#fff", border: "#7B9390 1px solid", borderRadius: "10px", width: "90%" }}>
                    <Typography sx={{ color: pcolor, fontSize: "1.5rem", margin: "10px 0px 5px 0px" }}>Uploaded Videos</Typography>
                    <Typography sx={{ color: rcolor, fontSize: "2.5rem", fontWeight: "bold", marginBottom: "10px" }}>{autismdata !== null ? autismdata.videoCount : loading ? <CircularProgress size={20} color="success" /> : ""}</Typography>
                  </Box></Grid>
                <Grid item xs={12} md={4}>
                  <Box mb={3} sx={{ textAlign: "center", backgroundColor: "#fff", border: "#7B9390 1px solid", borderRadius: "10px", width: "90%" }}>
                    <Typography sx={{ color: pcolor, fontSize: "1.5rem", margin: "10px 0px 5px 0px" }}>Uploaded reports</Typography>
                    <Typography sx={{ color: rcolor, fontSize: "2.5rem", fontWeight: "bold", marginBottom: "10px" }}>{autismdata !== null ? autismdata.reportCount : loading ? <CircularProgress size={20} color="success" /> : ""}</Typography>
                  </Box></Grid>
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box sx={footerContainer }>
        <Footer />
      </Box>
    </Box>
  );
}